// extracted by mini-css-extract-plugin
module.exports = {"anchor":"Anchor_anchor__FQpOT","target":"Anchor_target__13F5w"};